// extracted by mini-css-extract-plugin
export default {"textAnswer":"TextAnswer_textAnswer__pIu7h"};